import { TeamOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const ListAccountsPage = lazyRouteComponent(() => import('./pages/list'));

export const getRoutes = (): Route[] => [
  {
    page: ListAccountsPage,
    path: ROUTE_PATHS.ADMIN_ACCOUNTS,
    title: 'Contas',
    icon: TeamOutlined,
    adminSection: 'operation',
    adminOrder: 10,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
];
